import React from 'react';
import { AlertCircle } from 'lucide-react';

export const WizardChecklistBanner = ({ checklist, tr }) => {
  if (!checklist || checklist.length === 0) return null;
  return (
    <div className="mb-6 p-5 bg-red-50 border border-red-200 rounded-lg" data-testid="wizard-checklist">
      <div className="flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="font-semibold text-gray-900 mb-1">{tr('wizard.common.almostReady')}</p>
          <p className="text-sm text-gray-600 mb-3">{tr('wizard.common.almostReadyDesc')}</p>
          <ul className="space-y-3">
            {checklist.map((sec) => (
              <li key={sec.section || 'general'}>
                {sec.section && <p className="text-sm font-semibold text-gray-700">{sec.section}</p>}
                <ul className="list-disc pl-5 text-sm text-red-700 mt-1 space-y-0.5">
                  {sec.items.map((it) => (
                    <li key={it}>{it}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
